import { render, staticRenderFns } from "./collapse-item.vue?vue&type=template&id=cc47f2e0&scoped=true&"
import script from "./collapse-item.vue?vue&type=script&lang=js&"
export * from "./collapse-item.vue?vue&type=script&lang=js&"
import style0 from "./collapse-item.vue?vue&type=style&index=0&id=cc47f2e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc47f2e0",
  null
  
)

export default component.exports